<template>
  <div>
    <h5>Добавление клиента {{ order.client.phone }}</h5>
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    }
  },
  name: "filter",
  async created() {

  },
  methods: {
    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {
      this.$loading(true);


      logger(this.$http,{
          name:'Добавление пользователя в #PAYMART', 
          description: 'Начало запроса',
          model_type:'order',
          model_id : this.order.id
      });

      this.$http
        .post(`${this.partner['endpoint_url']}partner/buyers/send-sms-code`,
          {
            phone: this.order.client.phone
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case 'success':
                this.message = 'Успешно получили токен';
                this.$emit('getHash', response.data.hash);
                setTimeout(() => {
                  this.$emit('next', 2);
                }, 10);
                break;
              default:
                this.message = 'Пользователь заблокирован';
                break;
            }
          }
          this.$notify({
            title: "PAYMART",
            message: this.message,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          logger(this.$http,{
          name:'Добавление пользователя в #PAYMART', 
          description: this.message,
          model_type:'order',
          model_id : this.order.id
      });

        })
        .catch((error) => {
          alert('Ошибка партнера');

          logger(this.$http,{
            name:'Добавление пользователя в #PAYMART', 
            description: 'Ошибка партнера',
            model_type:'order',
            model_id : this.order.id
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: '',
      result: null,
      buyer_id: null
    };
  },
};
</script>
<style lang="scss">
</style>
